import axios from 'axios';

export default function (context) {
    context.dispatch('list/get', {
        data: context.getters['form/data'],
        cb: data => {
            context.commit('balance/set', data);
            context.commit('reports/set', data);
            context.commit('xls/set', {data, form: context.getters['form/data_report']});
        },
    });
}